



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Environment } from '@/interfaces/Environment';
import { Module } from '@/interfaces/Module';
import { ModuleHasEnvironment } from '@/interfaces/ModuleHasEnvironment';
import { CutoverplanHasEnvironment } from '@/interfaces/CutoverplanHasEnvironment';

@Component({})
export default class EnvironmentSelector extends Vue {
  @Prop()
  module!: Module;

  @Prop()
  selectedEnvironment!: number;

  get environments() {
    return [
      { name: 'DEFAULT', id: 0 },
      ...(this.module?.cutoverplan?.environments?.map(
        (e: CutoverplanHasEnvironment) => e.environment
      ) || [])
    ];
  }

  get selectedEnv() {
    return this.selectedEnvironment;
  }

  set selectedEnv(id: number) {
    this.$emit('setSelectedEnvironment', id);
  }

  get selectedEnvironmentName() {
    return (
      this.$store.state.all_environments.find(
        (environment: Environment) => environment.id === this.selectedEnv
      )?.name || 'DEFAULT'
    );
  }
}
